import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const AgencyNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Agency not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default AgencyNotFound



// WEBPACK FOOTER //
// ./src/components/Agencies/AgencyNotFound.jsx